import type { CashMovementDto } from '@barbeiropro/contracts';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { fmtTime } from '@/lib/format';
import { money } from '@/lib/format';
import { useTimezone } from '@/lib/org';
import { cn } from '@/lib/utils';
import { EmptyState } from '@/components/shared/states';
import { KIND_LABEL, MOVEMENT_LABEL, signed } from '../labels';

export function MovementsTable({ movements }: { movements: CashMovementDto[] }) {
  const tz = useTimezone();
  if (movements.length === 0) return <EmptyState title="Nenhum movimento ainda" description="Recebimentos, sangrias e suprimentos aparecem aqui." />;
  return (
    <div className="overflow-x-auto rounded-lg border bg-card">
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            <TableHead className="text-xs font-semibold text-muted-foreground">Hora</TableHead>
            <TableHead className="text-xs font-semibold text-muted-foreground">Tipo</TableHead>
            <TableHead className="text-xs font-semibold text-muted-foreground">Método</TableHead>
            <TableHead className="text-xs font-semibold text-muted-foreground">Motivo</TableHead>
            <TableHead className="text-right text-xs font-semibold text-muted-foreground">Valor</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {movements.map((m) => (
            <TableRow key={m.id}>
              <TableCell className="tabular">{fmtTime(m.createdAt, tz)}</TableCell>
              <TableCell>{MOVEMENT_LABEL[m.type]}</TableCell>
              <TableCell>{KIND_LABEL[m.methodKind]}</TableCell>
              <TableCell className="max-w-72 truncate text-muted-foreground" title={m.reason ?? undefined}>
                {m.reason ?? '-'}
                {m.actorName ? ` (${m.actorName})` : ''}
              </TableCell>
              <TableCell className={cn('tabular text-right font-medium', m.amountCents < 0 && 'text-oxblood-ink')}>{signed(m.amountCents, money)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
